import IconButton from '@zenbusiness/zui/IconButton';
import PropTypes from 'prop-types';

import { DialogStyled, DialogTitleStyled, EmptyDivStyled, TitleStyled } from './styles';

export default function FormInfoModal({
  title,
  handleClose,
  fullScreen = false,
  borderRadius = '0',
  children
}) {
  return (
    <DialogStyled
      borderRadius={borderRadius}
      disableRestoreFocus
      fullScreen={fullScreen}
      fullWidth
      maxWidth="md"
      onClose={handleClose}
      open
    >
      <DialogTitleStyled component="div">
        <EmptyDivStyled />
        <TitleStyled
          role="heading"
          size="xl"
          weight="medium"
        >
          {title ?? ''}
        </TitleStyled>
        <IconButton
          iconSrc="/icon/micro/close-x.svg"
          label="Close form modal"
          onClick={handleClose}
          size="sm"
        />
      </DialogTitleStyled>
      {children}
    </DialogStyled>
  );
}

FormInfoModal.propTypes = {
  children: PropTypes.node.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  fullScreen: PropTypes.bool,
  borderRadius: PropTypes.string
};
